import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import AdagioSwiper from 'js/components/AdagioSwiper'
import { BREAKPOINTS } from 'js/shared/swiper'
import Slide from './slide/Slide'
import './slider.scss'

const DOTS_THRESHOLD = 4

const hasImage = ({ image }) => typeof image !== 'undefined' && image.trim().length > 0

export default function VideoPhotoSlider({
  slides = [],
  children = [],
  onlyDots = false,
  twoCol = false,
}) {
  const hasChildren = children?.length > 0
  const validSlides = hasChildren ? [] : slides.filter(hasImage)
  const itemsCount = hasChildren ? children.length : validSlides.length

  const showDots = itemsCount > DOTS_THRESHOLD || onlyDots
  const isSingleItem = itemsCount <= 1

  const mainSlides = hasChildren
    ? children
    : validSlides.map((slide, key) => <Slide key={`slide-${key + 1}`} {...slide} />)

  return (
    <div className={cn('slider-component', { 'slider-component__one--item': isSingleItem })}>
      <div className="slide-container">
        <AdagioSwiper
          slidesPerView={twoCol ? 'auto' : 1}
          spaceBetween={0}
          skipPagination={!showDots}
          breakpoints={twoCol ? {
            [BREAKPOINTS.XL]: {
              slidesPerView: 2,
            },
          } : undefined}
        >
          {mainSlides}
        </AdagioSwiper>
      </div>
    </div>
  )
}

VideoPhotoSlider.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  onlyDots: PropTypes.bool,
  twoCol: PropTypes.bool,
}
